import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetDefaultExchangeUseCase extends BaseUseCase {
    constructor(getDefaultExchange) {
        super();
        this.getDefaultExchange = getDefaultExchange;
    }
    async fetchResult(req) {
        return await this.getDefaultExchange.defaultExchangeData(req);
    }
}
export default GetDefaultExchangeUseCase;
